module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ctN7X"))).then(() => module.bundle.root('1iHdE'));